import { render, staticRenderFns } from "./AnimationIcon.vue?vue&type=template&id=5473591e"
import script from "./AnimationIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnimationIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports